module.exports = __webpack_public_path__ + "__static/site-1749741178941/img/how-works-mobile--pt.3b45e87a.svg";